import { Typography, Card, CardHeader, IconButton, CardMedia, CardContent, CardActions } from '@mui/material';
import defaultImg from './defaultImage.png'
import { Grid2 as Grid, Stack } from '@mui/material';
import { useNavigate } from "react-router-dom";

const TurfCard = ({turf}) =>{ 
    const navigate = useNavigate();
    return (
        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 2 }}>
            <Card onClick={()=>{navigate(`/turf/${turf._id}`)}}>
                <CardMedia
                    component="img"
                    image={defaultImg}
                    alt="Paella dish"
                />
                <CardActions disableSpacing>
                    <Stack sx={{width: '100%'}} direction="row" alignItems="center" justifyContent="space-between">
                        <Typography sx={{fontWeight: 'bold'}}>{turf.name}</Typography>
                        <Typography>₹{turf.rate}/Hr</Typography>
                    </Stack>
                </CardActions>
            </Card>
        </Grid>

    )
}

export default TurfCard